import React, { useEffect, useState } from 'react';
import styled from 'App/styled';
import statusCodes from 'constants/statusCodes';
import { MWEB } from 'constants/devices';
import Widgets from 'components/Widgets/View';
import { TRACKING_PAGE_TYPES } from 'components/CartOperations/constants';
import { getWidgets } from 'store/adPlatform/service';
import { logger } from '@nykaa/logger';
import {
  NOT_FOUND_TEXT,
  NOT_FOUND_IMAGE,
  NOT_FOUND_SUBTEXT,
  FETCH_ACTION_ERROR,
  POPULAR_BRAND,
  FETCH_ERROR,
  POPULAR_BRNAD2,
  GO_BACK_TEXT,
  ERROR_TEXT,
  NOT_FOUND_IMAGE_V2,
  GO_TO_HOMEPAGE,
  NOT_FOUND_SUBTEXT_V2,
} from '../constant';
import { pushEvent } from '@nykaa/data-layer';

const getStatusText = (statusCode: number) => {
  switch (statusCode) {
    case statusCodes.NOT_FOUND:
      return NOT_FOUND_TEXT;

    default:
      return ERROR_TEXT;
  }
};

const getStatusSubText = (statusCode: number, showPageNotFoundV2: boolean) => {
  switch (statusCode) {
    case statusCodes.NOT_FOUND:
      return showPageNotFoundV2 ? NOT_FOUND_SUBTEXT_V2 : NOT_FOUND_SUBTEXT;

    default:
      return '';
  }
};

const Container = styled.div<{ showPageNotFoundV2: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  justify-content: center;
  min-height: ${({ showPageNotFoundV2 }) =>
    showPageNotFoundV2 ? '68vh' : '80vh'};
  background: ${({ theme }) => theme.colors.snow100};
  ${({ showPageNotFoundV2, theme }) =>
    showPageNotFoundV2 && `padding-top: ${theme.spacing.spacing100}`};
  .image {
    max-width: 100%;
  }

  .status-text {
    width: 100%;
    padding: ${({ theme }) => theme.spacing.spacing0}
      ${({ theme }) => theme.spacing.spacing160};
    ${({ theme }) => theme.typography.type242};
    color: ${({ theme }) => theme.colors.pebble900};
    text-align: center;
  }

  .status-sub-text {
    width: 100%;
    padding: ${({ theme: { spacing } }) =>
      `${spacing.spacing0} ${spacing.spacing160} ${spacing.spacing100} ${spacing.spacing160}`};
    ${({ theme }) => theme.typography.type160};
    color: ${({ theme }) => theme.colors.pebble900};
    text-align: center;
  }

  .home-link {
    font-weight: bold;
    padding: 12px 20px;
    font-size: 0.9rem;
    border-radius: 4px;
    text-decoration: none;
    background: #fc2779;
    color: ${({ theme }) => theme.colors.snow100};
  }
`;

const WidgetWrapper = styled.div`
  margin-top: ${({ theme }) => theme.spacing.spacing200};
  margin-bottom: ${({ theme }) => theme.spacing.spacing40};
`;

interface ErrorProps {
  statusCode: number;
  showPageNotFoundV2: boolean;
}

const ERROR_PAGE_LOAD_EVENT = 'errorPageLoad';

function Error({ statusCode, showPageNotFoundV2 }: ErrorProps) {
  const [popularBrandsWidget, setPopularBrandsWidget] = useState([]);
  const fetchPopularBrandsWidgets = async (params: any) => {
    const requestParams = {
      ...params,
    };
    try {
      const { widgets } = await getWidgets(requestParams, '');
      return widgets;
    } catch (err) {
      logger.error(err, FETCH_ERROR);
    }
  };

  useEffect(() => {
    const widgetParams = {
      page_type: 'beauty-app-no-search-results-revamp',
      page_data: 'default',
      page_section: '*',
      device: 'mobile',
      platform: MWEB,
      api_version: '',
    };
    fetchPopularBrandsWidgets(widgetParams)
      .then((data) => {
        const brandsData = data.filter(
          (widget: { inventoryPageSection: string }) =>
            widget.inventoryPageSection === POPULAR_BRAND ||
            widget.inventoryPageSection === POPULAR_BRNAD2
        );
        setPopularBrandsWidget(brandsData);
      })
      .catch((err) => {
        logger.error(err, FETCH_ACTION_ERROR);
      });
  }, []);

  const statusText = getStatusText(statusCode);

  useEffect(() => {
    if (statusCode === statusCodes.NOT_FOUND)
      pushEvent(ERROR_PAGE_LOAD_EVENT, {
        statusText,
      });
  }, [statusCode, statusText]);
  return (
    <Container showPageNotFoundV2={showPageNotFoundV2}>
      <img
        className="image"
        src={showPageNotFoundV2 ? NOT_FOUND_IMAGE_V2 : NOT_FOUND_IMAGE}
        alt="not found"
        height={showPageNotFoundV2 ? 162 : 250}
      />
      <h1 className="status-text">{getStatusText(statusCode)}</h1>
      {statusCode === statusCodes.NOT_FOUND && (
        <h2 className="status-sub-text">
          {getStatusSubText(statusCode, showPageNotFoundV2)}
        </h2>
      )}
      <a
        href="/"
        className="home-link"
      >
        {showPageNotFoundV2 ? GO_TO_HOMEPAGE : GO_BACK_TEXT}
      </a>
      {popularBrandsWidget &&
        popularBrandsWidget.length > 0 &&
        statusCode === statusCodes.NOT_FOUND && (
          <WidgetWrapper>
            <Widgets
              widgets={popularBrandsWidget}
              pageName={TRACKING_PAGE_TYPES.NOT_FOUND}
            />
          </WidgetWrapper>
        )}
    </Container>
  );
}

export default Error;
